import ceoSehee from "../assets/images/ceo-sehee.jpg"

function Intr() {
  return (
    <div className="inner">
      {/* <h2>About <b>바른</b></h2> */}
      <section>
        <div className="wrap-col2 ">
          <div className="wrap-txt">
            <p><b>안녕하세요.<br />바른 법무사 사무소 대표 법무사 안세희입니다.</b></p>
          </div>
          <div className="wrap-img">
            <img src={ceoSehee} alt="법무사 안세희" />
          </div>
        </div>
        <div className="wrap-col2">
          <div className="wrap-txt">
            <p>우리 바른 법무사 사무소는 현대 사회에서 발생하는 다양한 법률 분쟁을 해결할 뿐만 아니라, 우리 주변에서 자주 일어나고 있는 소송, 민사집행, 상업등기, 부동산등기, 상속, 개인회생 및 파산 등 원하는 사항을 신속히 해결하여 항상 의뢰인과 함께하는 동반자가 되고자 하는 이념을 가지고 있습니다.</p>
            <p>단순한 법률지식을 제공하는 것이 아니라 올바른 선택을 할 수 있는 방법을 제시하며 빠르고 합리적인 비용 등을 통하여 의뢰인이 원하는 최상의 만족을 얻도록 최선을 다할 것을 약속드립니다.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Intr;
